export const shortenName = (name, maxLength = 50) => {
  return name?.length > maxLength ? `${name.substring(0, maxLength)}...` : name;
};
